//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../Motion/Motion.LinkAttachmentData.js";
import "../Motion/Motion.SelectJoint.js";
import "../Motion/Motion.SelectLink.js";
import "../Motion/Motion.SelectControlPort.js";
import "../no/SelectObject.js";
let d=[[[1,"ActionLinkAttachment",0,"Motion.LinkAttachmentData",0],[0,"Application",1,0],[1,"BaseLinkAttachment",0,"Motion.LinkAttachmentData",0],[0,"Direction",1,0],[1,"JointSelection",0,"Motion.SelectJoint",0],[1,"MassPropertyMotionBody",0,"Motion.SelectLink",0],[0,"MassPropertyMotionBodyOvrCtrl",1,0],[0,"MassPropertyType",1,0],[0,"Name",1,0],[0,"OutputType",1,0],[1,"PortSelection",0,"Motion.SelectControlPort",0],[0,"PortSelectionOvrCtrl",1,0],[0,"SolutionVariableType",1,0],[0,"Variable",1,0],[1,"XCoordinatePortSelection",0,"Motion.SelectControlPort",0],[0,"XCoordinatePortSelectionOvrCtrl",1,0],[1,"YCoordinatePortSelection",0,"Motion.SelectControlPort",0],[0,"YCoordinatePortSelectionOvrCtrl",1,0],[1,"ZCoordinatePortSelection",0,"Motion.SelectControlPort",0],[0,"ZCoordinatePortSelectionOvrCtrl",1,0]],[],[]];
SPLM.Motion.ControlOutputBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.ControlOutputBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.ControlOutputBuilder.ControlOutputType = Object.freeze({
    "Link" : "Link", "JointOrConstraint" : "JointOrConstraint", "MassProperty" : "MassProperty", "Solution" : "Solution"});

SPLM.Motion.ControlOutputBuilder.VariableType = Object.freeze({
    "Force" : "Force", "Torque" : "Torque", "ActionTorque" : "ActionTorque", "BaseTorque" : "BaseTorque", "BaseForce" : "BaseForce"});

SPLM.Motion.ControlOutputBuilder.DirectionType = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z"});

SPLM.Motion.ControlOutputBuilder.ApplicationType = Object.freeze({
    "ActionReaction" : "ActionReaction", "ActionOnly" : "ActionOnly"});

SPLM.Motion.ControlOutputBuilder.MassPropertyTypes = Object.freeze({
    "Mass" : "Mass", "Ixx" : "Ixx", "Iyy" : "Iyy", "Izz" : "Izz", "Ixy" : "Ixy", "Ixz" : "Ixz", "Iyz" : "Iyz", "CGOffsetX" : "CGOffsetX", "CGOffsetY" : "CGOffsetY", "CGOffsetZ" : "CGOffsetZ"});

SPLM.Motion.ControlOutputBuilder.SolutionVariableTypes = Object.freeze({
    "Reset" : "Reset", "GravityVector" : "GravityVector", "EnableResultsReport" : "EnableResultsReport"});

export default SPLM;